///<reference path="../api.d.ts" />
///<reference path="../../../shared/address/address-controller.ts" />
///<reference path="../../../../typings/tsd.d.ts" />

module agencyRegistration.controller {

    import material = angular.material;
    
    export class CreateController {
        // Dependencies
        addressService: address.AddressService;
        
        // Properties
        loader : common.Loader = new common.Loader(); 
        addressLoader: common.Loader = new common.Loader();
        fieldOptions: any;
        agency: API.Client.AgencyModel;
        addressConfig: address.controller.AddressConfig; 
        
        /*@ngInject*/
        constructor(
            $rootScope: ng.IScope,
            agentFactory: agencyRegistration.factory.agentFactory, 
            createService: agencyRegistration.service.CreateService,
            addressService: address.AddressService
        ) { 
            // Dependencies
            this.addressService = addressService;
            
            // Properties
            this.addressConfig = new address.controller.AddressConfig();
            this.agency = agentFactory.getAgency();
            
            // Get Fields
            this.loader.showLoader("Carregando...");
            
            createService.getFields().then(fields => {
                this.fieldOptions = fields;
                this.addressConfig.cities = fields.cities;
            }).finally(() => { this.loader.hide(); });
            
            $rootScope["$createLoader"] = this.loader;
        };
        
        getCity():void{
            this.addressConfig.loader.showLoader("Carregando cidades...");
            
            this.addressService.getCity(this.agency.address.countryCode, this.agency.address.stateCode).then(cities => {
                this.addressConfig.cities = cities;
                this.agency.address.cityCode = cities[0].code;
            }).finally(() => {
                this.addressConfig.loader.hide();
            });
        };
        
        addPhoneItem():void {
            this.agency.companyData.phones.push({ type: 'T' });
        };
        
        removePhoneItem(item: API.Client.PhoneModel) {
            let index = this.agency.companyData.phones.indexOf(item);
            this.agency.companyData.phones.splice(index, 1);
        };
    }
}

angular.module('agencyRegistrationApp').controller('CreateController', agencyRegistration.controller.CreateController);
